export enum OpenSeaNftValidatorStageId {
  NULL = 0,
  FORM = 1,
  RESULT = 2,
  CONNECTED = 3,
}
